<script>
import * as icons from 'vue-feather-icons'

export default {
  name: 'FeatherIcon',
  inheritAttrs: false,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
  },
  render(h) {
    const icon = typeof this.icon === 'string' ? icons[this.icon] : this.icon

    // Create Feather Icon
    const svg = h(icon, {
      attrs: this.$attrs,
      on: this.$listeners,
      props: {
        size: this.size,
      },
    })

    // If no badge is provided => Render just SVG
    if (!this.badge) return svg

    // Badge
    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: this.badgeClasses }, [this.badge])

    // Return span with children
    return h('span', { staticClass: 'feather-icon position-relative' }, [svg, badgeEl])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}
</style>
